<vc-button
    mode="icon-secondary"
    iconName="move_down"
    [tooltip]="'REORDER_TASK.REORDER' | transloco"
    [disabled]="disabled"
    (trigger)="trigger.emit()"></vc-button>
@if (tooltip) {
    <vc-icon
        class="space-pd-top-8 space-pd-left-16"
        name="info_outline"
        color="var(--primary-500)"
        tooltipPosition="above"
        [tooltip]="tooltip"></vc-icon>
}
